<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar flat color="#008dd4" dark>
                <v-btn icon @click="$parent.edit_dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Editar Alumno</v-toolbar-title>
            </v-toolbar>
            <v-container>
                <v-form v-model="form" ref="edit" v-on:submit.prevent="submit($event)">
                    <v-row>
                        <v-col cols="12" lg="6" md="10" class="mx-auto">
                            <v-text-field v-model="item.names" :rules="[rules.required]" filled label="Nombre(s)" clearable :color="color" append-icon="mdi-account"></v-text-field>
                            <v-row no-gutters>
                                <v-text-field v-model="item.paternal_surname" :rules="[rules.required]" filled label="Apellido paterno" clearable :color="color"></v-text-field>
                                <v-text-field v-model="item.maternal_surname" :rules="[rules.required]" filled label="Apellido materno" clearable :color="color"></v-text-field>
                                <v-text-field v-model="item.phone" type="number" :rules="[rules.required, rules.phone]" filled label="Telefono" clearable :color="color" append-icon="mdi-phone"></v-text-field>
                            </v-row>
                            <p>Datos de usuario</p>
                            <v-text-field
                                v-model="item.email"
                                filled
                                label="Correo electrónico"
                                :error-messages="email_error_messages"
                                :rules="[rules.required, rules.email]"
                                clearable
                                :color="color"
                                append-icon="mdi-at"
                            ></v-text-field>
                            <v-text-field
                                v-model="item.name"
                                filled
                                label="Nombre de usuario"
                                :error-messages="name_error_messages"
                                clearable
                                :rules="[rules.required]"
                                :color="color"
                                append-icon="mdi-account-circle"
                            ></v-text-field>
                            <v-text-field v-model="password" type="password" :rules="[rules.length]" hint="Debe contener al menos 8 caracteres" filled label="Nueva contraseña" :color="color"></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" lg="6" md="10" class="text-right mx-auto">
                            <v-btn type="submit" :loading="loading" color="#008dd4" dark>Actualizar</v-btn>
                            <v-btn @click="cancel" :disabled="loading" text>Cancelar</v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>

import iziToast from 'izitoast'

export default {
    props:['dialog', 'update_url', 'item'],
    data:() => ({
        color:"#000",
        rules:{
            required: v => !!v || 'El campo es requerido',
            email: v => /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/.test(v) || 'El Correo electrónico ingresado no es válido',
            length: v  => !v || v.length >= 8 || 'Debe contener al menos 8 caracteres',
            phone: v => !!v && v.length >= 10 || 'Debe contener al menos 10 caracteres'
        },

        form:false,

        //props
        color: "#000",
        loading:false,
        email_error_messages:"",
        name_error_messages:"",
        error_message:"",

        password:"",
    }),

    watch:{
        password:function(val){
            this.password_confirmation = ""

        },

        password_confirmation:function(val){
            if(val !== ""){
                this.error_message = val !== this.password ? "Las contraseñas no coinciden" : ""
            }else{
                this.$refs.password_confirmation.reset()
            }
        }
    },

    methods:{

        submit:function(){
            if(this.$refs.edit.validate()){
                this.loading = true

                let data = new Object()
                data.id                    = this.item.id
                data.name                  = this.item.name
                data.names                 = this.item.names
                data.phone                 = this.item.phone
                data.email                 = this.item.email
                data.password              = this.password
                data.paternal_surname      = this.item.paternal_surname
                data.maternal_surname      = this.item.maternal_surname

                axios.post(this.update_url, data).then(response => {
                    if(response.data.success){
                        this.cancel()

                        iziToast.success({
                            title:"Correcto",
                            position:"topRight",
                            message:"Alumno actualizado correctamente"
                        })

                        this.$parent.getData()
                    }
                }).catch(error => {
                    this.loading = false
                    if(error.response.data.errors){
                        for(let prop in error.response.data.errors){
                            for(let message of error.response.data.errors[prop]){
                                iziToast.error({
                                    title:"Error",
                                    position:'topRight',
                                    message: message
                                })
                            }
                        }
                    }
                })

            }
        },

        cancel:function(){
            this.loading = false
            this.$refs.edit.reset()
            this.$parent.edit_dialog = false
        }

    }

}
</script>
